import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/spell/`;

class cdoSpell {
    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }
}

const cdo = new cdoSpell();
export default cdo;
